import { render, staticRenderFns } from "./medalTop3.vue?vue&type=template&id=d1e92a70&scoped=true"
import script from "./medalTop3.vue?vue&type=script&lang=js"
export * from "./medalTop3.vue?vue&type=script&lang=js"
import style0 from "./medalTop3.vue?vue&type=style&index=0&id=d1e92a70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e92a70",
  null
  
)

export default component.exports